import { IconKeys } from '../../Icon/IconKeys';
import Icon from '../../Icon/Icon';
import Props from './types';
import S from './StartEndTimeStyles';

function StartEndTime({ startTime, endTime, oldestFirst }: Props):JSX.Element {
  const startRow = (
    <div className="time-container">
      <p>Start at</p>
      <span>{startTime}</span>
    </div>
  );
  const endRow = (
    <div className="time-container">
      <p>End at</p>
      <span>{endTime}</span>
    </div>
  );
  return (
    <S.Wrapper>
      <Icon iconKey={IconKeys.TIME} />
      <div className="description">
        {oldestFirst ? (
          <>
            {startRow}
            {endRow}
          </>
        ) : (
          <>
            {endRow}
            {startRow}
          </>
        )}
      </div>
    </S.Wrapper>
  );
}

export default StartEndTime;
